import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from './Navbar';

// Dummy Data (replace this with your actual blogPosts array from '../data/contant')
const blogPosts = [
  { id: 1, title: 'EMPLOYERS', link: '/employers' },
  { id: 2, title: 'COLLEGES', link: '/colleges' },
  { id: 3, title: 'TRAINING CENTERS', link: '/training-centers' },
  { id: 4, title: 'NGO/PUBLIC ORGANIZATION', link: '/ngo' },
  { id: 5, title: 'PUBLIC RELATION ORGANIZATIONS', link: '/public-relations' },
  { id: 6, title: 'INNOVATION & ENGAGEMENTS', link: '/innovation' },
  { id: 7, title: 'Corporate Partners', link: '/corporate' },
  { id: 8, title: 'Foundations & Institutions', link: '/foundations' },
  { id: 9, title: 'Government Partners', link: '/government' },
  { id: 10, title: 'Knowledge Partners', link: '/knowledge' },
  { id: 11, title: 'Testimonial', link: '/testimonial' },
  { id: 12, title: 'Partner with Us', link: '/partner' },
];

// Animations
const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.5,
      ease: 'easeOut',
    },
  }),
};

const pageVariant = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: 'easeOut',
    },
  },
};

const PartnerCard = ({ id, title, link, index }) => {
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);

  const handleClick = () => {
    setShowForm((prev) => !prev); // Toggle form visibility
  };

  return (
    <motion.div
      custom={index}
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      className="w-full md:w-1/3 p-4"
    >
      <div className="bg-white shadow-md rounded p-6 hover:shadow-xl transition-shadow duration-300">
        <h3
          className="text-xl font-semibold text-gray-800 hover:text-blue-600 hover:underline cursor-pointer"
          onClick={handleClick}
        >
          {title}
        </h3>

        {showForm && (
          <form className="mt-4 space-y-3">
            <input
              type="text"
              placeholder="Name"
              className="w-full border rounded px-3 py-2 text-sm"
            />
            <input
              type="email"
              placeholder="Email"
              className="w-full border rounded px-3 py-2 text-sm"
            />
            <input
              type="tel"
              placeholder="Phone"
              className="w-full border rounded px-3 py-2 text-sm"
            />
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 text-sm"
            >
             Login
            </button>
          </form>
        )}
      </div>
    </motion.div>
  );
};


PartnerCard.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
};

const PartnerPage = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 9;

  const totalPosts = blogPosts.length;
  const totalPages = Math.ceil(totalPosts / postsPerPage);
  const startIndex = (currentPage - 1) * postsPerPage;
  const currentPosts = blogPosts.slice(startIndex, startIndex + postsPerPage);

  return (
    <>
      <Navbar />
      <motion.section
        className="py-16 bg-gray-100"
        initial="hidden"
        animate="visible"
        variants={pageVariant}
      >
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Partners</h2>
          <div className="flex flex-wrap -mx-4">
            {currentPosts.map((post, index) => (
              <PartnerCard key={post.id} {...post} index={index} />
            ))}
          </div>

          {totalPages > 1 && (
            <div className="flex justify-center mt-8 space-x-2">
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index + 1}
                  onClick={() => {
                    setCurrentPage(index + 1);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className={`px-4 py-2 rounded ${
                    currentPage === index + 1
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                  }`}
                  aria-label={`Go to page ${index + 1}`}
                >
                  {index + 1}
                </button>
              ))}
            </div>
          )}
        </div>
      </motion.section>
    </>
  );
};

export default PartnerPage;
